import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/ProjectCard.css';

const ProjectCard = ({ image, title, description, githubLink, liveDemoLink, blogLink }) => {
  return (
    <div className='project-card'>
      <img src={image} alt='Project' className='project-image' />
      <p className='project-title'>{title}</p>
      <p className='project-description'>{description}</p>

      <div className="project-links">
        {githubLink && (
          <a href={githubLink} target='_blank' rel='noopener noreferrer' className='project-link'>
            GitHub
          </a>
        )}
        {liveDemoLink && (
          <a href={liveDemoLink} target='_blank' rel='noopener noreferrer' className='project-link'>
            Live Demo
          </a>
        )}
        {blogLink && (
          <Link to={blogLink} className='project-link'>
            Blog
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
